// import React from "react";
// import "./Footer.css";

// import FacebookIcon from "../../assets/footer/facebook.svg";
// import InstagramIcon from "../../assets/footer/instagram.svg";
// import WhatsappIcon from "../../assets/footer/whatsapp.svg";
// import LinkedInIcon from "../../assets/footer/linkedin.svg";
// import BehanceIcon from "../../assets/footer/behance.svg";

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-top">
//         <div className="footer-col">
//           <h3>Address</h3>
//           <p>
//             West/Shop 303, Siddharaj Z Square,
//             <br />
//             Kudasan, Gandhinagar, Gujarat 382421.
//           </p>
//         </div>
//         <div className="footer-col">
//           <h3>For Jobs</h3>
//           <p>recruiter@webbunny.in</p>
//           <p>+91 9825018814</p>
//         </div>
//         <div className="footer-col">
//           <h3>For business</h3>
//           <p>contact@webbunny.in</p>
//           <p>+91 9825018814</p>
//         </div>
//         <div className="footer-col">
//           <h3>Follow us</h3>
//           <div className="social-icons">
//             {/* <img src={FacebookIcon} alt="Facebook" />
//             <img src={InstagramIcon} alt="Instagram" />
//             <img src={WhatsappIcon} alt="Whatsapp" />
//             <img src={LinkedInIcon} alt="LinkedIn" />
//             <img src={BehanceIcon} alt="Behance" /> */}
//             <a
//               href="https://www.facebook.com/webbunny1993/"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={FacebookIcon} alt="Facebook" />
//             </a>
//             <a
//               href="https://www.instagram.com/webbunnydevelopment"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={InstagramIcon} alt="Instagram" />
//             </a>
//             <a
//               href="https://wa.me/+919825018814"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={WhatsappIcon} alt="Whatsapp" />
//             </a>
//             <a
//               href="https://www.linkedin.com/company/webbunnydevelopment"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={LinkedInIcon} alt="LinkedIn" />
//             </a>
//             <a
//               href="https://www.behance.net/webbunnydevelopment/projects"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img src={BehanceIcon} alt="Behance" />
//             </a>
//           </div>
//         </div>
//       </div>

//       <hr className="footer-divider" />

//       <div className="footer-bottom">
//         <p>© 2025 Webbunny All rights reserved.</p>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <h3>Address</h3>
          <p>
            West/Shop 303, Siddharaj Z Square,
            <br />
            Kudasan, Gandhinagar, Gujarat 382421.
          </p>
        </div>
        <div className="footer-col">
          <h3>For Jobs</h3>
          <p>recruiter@webbunny.in</p>
          <p>+91 9512213133</p>
        </div>
        <div className="footer-col">
          <h3>For Business</h3>
          <p>contact@webbunny.in</p>
          <p>+91 9825018814</p>
        </div>
        <div className="footer-col">
          <h3>Follow us</h3>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/webbunny1993/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/footer/facebook.svg" alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/webbunnydevelopment"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/footer/instagram.svg" alt="Instagram" />
            </a>
            <a
              href="https://wa.me/+919825018814"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/footer/whatsapp.svg" alt="Whatsapp" />
            </a>
            <a
              href="https://www.linkedin.com/company/webbunnydevelopment"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/footer/linkedin.svg" alt="LinkedIn" />
            </a>
            <a
              href="https://www.behance.net/webbunnydevelopment/projects"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/footer/behance.svg" alt="Behance" />
            </a>
          </div>
        </div>
      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom">
        <p>© 2025 Webbunny All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
